// extracted by mini-css-extract-plugin
export default {"container":"VrIn3BTq064PIdBtYFsE","paymentInfo":"Pap7Xk4RDRVSPjQexJyN"};